import { FetchError, FetchSuccess, fetchV3 } from "..";

export const getAllWorkspaces = async (offset) => {
  try {
    const res = await fetchV3(`get-admin-workspaces?offset=${offset}`, null, {
      page: "/",
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch Workspaces");
  }
};

export const searchWorkspaces = async (offset, search) => {
  try {
    const res = await fetchV3(
      `search-admin-workspaces?search=${search}&offset=${offset}`,
      null,
      {
        page: "/",
      }
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch Workspaces");
  }
};

export const createWorkspace = async (body) => {
  try {
    const res = await fetchV3(
      "create-workspace",
      {
        method: "POST",
        body: JSON.stringify(body),
      },
      {
        page: "/",
      }
    );
    return new FetchSuccess(res, "Workspace created successfully");
  } catch (res) {
    throw new FetchError(res, "Failed to create Workspace");
  }
};

export const updateWorkspace = async (workspaceName, id) => {
  try {
    const res = await fetchV3(
      `update-workspace/${id}`,
      {
        method: "PATCH",
        body: JSON.stringify({ title: workspaceName }),
      },
      {
        page: "/",
      }
    );
    return new FetchSuccess(res, "Workspace updated successfully");
  } catch (res) {
    throw new FetchError(res, "Failed to create Workspace");
  }
};

export const addWorkspaceToFavorite = async (id) => {
  try {
    const res = await fetchV3(
      `add-remove-to-favorite/${id}`,
      {
        method: "POST",
      },
      {
        page: "/",
      }
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to add Workspace to favorite");
  }
};

export const getFavoriteList = async () => {
  try {
    const res = await fetchV3("favorite-workspaces-list", null, {
      page: "/",
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch Workspaces");
  }
};

export const deleteWorkspace = async (id) => {
  try {
    const res = await fetchV3(
      `delete-workspace/${id}`,
      {
        method: "DELETE",
      },
      {
        page: "/",
      }
    );
    return new FetchSuccess(res, "Workspace deleted successfully");
  } catch (res) {
    throw new FetchError(res, "Failed to delete Workspace");
  }
};

export const getWorkspaceEvents = async (id, offset) => {
  try {
    const res = await fetchV3(
      `get-workspace-events/${id}?offset=${offset}`,
      null,
      {
        page: "/",
      }
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch workspace events");
  }
};

export const getWorkspace = async (id) => {
  try {
    const res = await fetchV3(`workspaces/${id}`, null, {
      page: "/",
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch workspace");
  }
};

export const getAdminWorkspaces = async () => {
  try {
    const res = await fetchV3(`get-admin-workspaces`, null, {
      page: "/",
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch workspaces");
  }
};

export const getWorkspaceCollaborators = async (id) => {
  try {
    const res = await fetchV3(`get-workspace-collaborators/${id}`, null, {
      page: "/",
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch workspace collaborators");
  }
};

export const getOnlyWorkspaceCollaborators = async (id) => {
  try {
    const res = await fetchV3(`get-share-workspace-collaborators/${id}`, null, {
      page: "/",
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch workspace collaborators");
  }
};

export const getWorkspaceDetails = async (id) => {
  try {
    const res = await fetchV3(`workspace-details/${id}`, null, {
      page: "/",
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch workspace details");
  }
};

export const moveWorkspaceEvent = async (eventId, workspaceId) => {
  try {
    const res = await fetchV3(
      `move-event/${workspaceId}/${eventId}`,
      { method: "PATCH" },
      {
        page: "/",
      }
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to move workspace event");
  }
};

export const deleteWorkspaceEvent = async (eventId) => {
  try {
    const res = await fetchV3(
      `events/${eventId}`,
      { method: "DELETE" },
      {
        page: "events",
      }
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to delete workspace event");
  }
};

// export const deleteWorkspace = async (workspaceId) => {
//     try {
//         const res = await fetchV3(`delete-workspace/${workspaceId}`, { method: "DELETE" }, {
//             page: "/",

//         });
//         return new FetchSuccess(res);
//     } catch (res) {
//         throw new FetchError(res, "Failed to delete workspace");
//     }
// }

export const searchCollaborators = async (query) => {
  try {
    const res = await fetchV3(`search-collaborators?search=${query}`, null, {
      page: "/",
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to search collaborators");
  }
};

export const getAdminRoles = async () => {
  try {
    const res = await fetchV3(`get-admin-roles`, null, {
      page: "/",
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch admin roles");
  }
};

export const shareWorkspace = async (workspaceId, payload) => {
  try {
    const res = await fetchV3(
      `share-workspace/${workspaceId}`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      {
        page: "/",
      }
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to share workspace");
  }
};

export const updateWorkspaceRole = async (workspaceId, payload) => {
  try {
    const res = await fetchV3(
      `update-workspace-access-role/${workspaceId}`,
      {
        method: "PATCH",
        body: JSON.stringify(payload),
      },
      {
        page: "/",
      }
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to update workspace role");
  }
};

export const removeCollaboratorFromWorkspace = async (
  workspaceId,
  type,
  collaboratorId
) => {
  try {
    const res = await fetchV3(
      `remove-collaborators/${workspaceId}/${type}/${collaboratorId}`,
      {
        method: "DELETE",
      },
      {
        page: "/",
      }
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to remove collaborator from workspace");
  }
};

export const removeCollaboratorFromEvent = async (
  workspaceId,
  type,
  collaboratorId,
  eventId
) => {
  try {
    const res = await fetchV3(
      `remove-collaborators-from-event/${workspaceId}/${type}/${collaboratorId}/${eventId}`,
      {
        method: "DELETE",
      },
      {
        page: "/",
      }
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to remove collaborator from e vent");
  }
};

export const shareEventWithCollaborators = async (workspaceId, eventId, payload) => {
  try {
    const res = await fetchV3(
      `share-event/${workspaceId}/${eventId}`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      {
        page: "/",
      }
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to share event with collaborators");
  }
}

export const getEventCollaborators = async (eventId, workspaceId) => {
  try {
    const res = await fetchV3(`get-event-collaborators/${workspaceId}/${eventId}`, null, {
      page: "/",
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch event collaborators");
  }
}

export const updateEventRole = async (workspaceId, eventId, payload) => {
  try {
    const res = await fetchV3(
      `update-event-access-role/${workspaceId}/${eventId}`,
      {
        method: "PATCH",
        body: JSON.stringify(payload),
      },
      {
        page: "/",
      }
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to update event role");
  }
}